module.exports = __webpack_public_path__ + "img/reservation.6921c983.png";